<span ngForm #frm="ngForm">
  <mat-checkbox
        [ngClass]="styleClass"
        [color]="color"
        [checked]="checked"
        [labelPosition]="labelPosition"
        [disabled]="disabled"
        [value]="value"
        [indeterminate]="false"
        (change)="toggle()"
        [(ngModel)]="result"
        (ngModelChange)="onModelChanged($event)"
        [appCustomPatternValidator]="fieldValidationConstraints"
        name="{{name}}" #control="ngModel">
  {{ label }}
</mat-checkbox>
<mat-error *ngIf="(this.error ||  frm.controls[name]?.errors?.regexp) && frm.controls[name]?.invalid && (frm.controls[name]?.touched || frm.controls[name].dirty) ">
  <ng-container *ngIf="frm.controls[name].errors?.regexp">
    {{ frm.controls[name].errors.regexp }}
  </ng-container>
  <ng-container *ngIf="!frm.controls[name].errors?.regexp">
    {{ error }}
  </ng-container>
</mat-error>
</span>

